// Fetch list

export const FETCH = 'vehiclePositions.FETCH'
export const FETCH_STARTED = 'vehiclePositions.FETCH_STARTED'
export const FETCH_FULFILLED = 'vehiclePositions.FETCH_FULFILLED'
export const FETCH_REJECTED = 'vehiclePositions.FETCH_REJECTED'
export const FETCH_CANCELLED = 'vehiclePositions.FETCH_CANCELLED'
